module.exports = __webpack_public_path__ + "static/media/arrow-right.baf270c0.svg";